import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { track } from "../lib/site";

export const AvailabilityBar = () => {
  const { rooms, openBooking } = useSite();
  const [form, setForm] = useState({ check_in: "", check_out: "", guests: "2", room: "" });
  const update = (key) => (event) => setForm({ ...form, [key]: event.target.value });

  const submit = (event) => {
    event.preventDefault();
    track("check_availability_click", { check_in: form.check_in, check_out: form.check_out, guests: form.guests, room: form.room || "any" });
    openBooking({ prefill: form });
  };

  return (
    <motion.section
      className="availability-wrap"
      initial={{ opacity: 0, y: 34 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, delay: 1.05, ease: [0.22, 1, 0.36, 1] }}
      data-testid="availability-bar"
    >
      <form className="availability-form" onSubmit={submit} data-testid="availability-form">
        <label>Check in
          <input type="date" value={form.check_in} onChange={update("check_in")} required data-testid="availability-check-in" />
        </label>
        <label>Check out
          <input type="date" value={form.check_out} onChange={update("check_out")} required data-testid="availability-check-out" />
        </label>
        <label>Guests
          <select value={form.guests} onChange={update("guests")} data-testid="availability-guests">
            {[1, 2, 3, 4, 5, 6].map((n) => <option key={n} value={n}>{n} Guest{n > 1 ? "s" : ""}</option>)}
          </select>
        </label>
        <label>Room
          <select value={form.room} onChange={update("room")} data-testid="availability-room">
            <option value="">Any stay</option>
            {rooms.map((room) => <option key={room.id} value={room.name}>{room.name}</option>)}
          </select>
        </label>
        <button type="submit" className="gold-button availability-submit" data-testid="availability-submit">
          Check availability <ArrowUpRight size={16} />
        </button>
      </form>
    </motion.section>
  );
};
